import { useState } from "react";
import useCartStore from "../../utils/cartStore";

const PRICE_PER_PIECE = 4;
const IMAGES = [
  "/images/cafe_gourmands/cafe_gourmand.jpg",
  "/images/cafe_gourmands/cafe_gourmand_interieur.jpg",
];

const CafeBoxCalculator = () => {

  const addToCart = useCartStore(state => state.addToCart);

  const [quantity, setQuantity] = useState(4);
  const [selectedImage, setSelectedImage] = useState(0);

  const increase = () => {
    setQuantity(q => q + 2);
  };

  const decrease = () => {
    setQuantity(q => (q > 4 ? q - 2 : q));
  };

  const price = quantity * PRICE_PER_PIECE;

  const handleAddToCart = () => {

    addToCart(
      {
        id: `cafes-gourmands-${quantity}`,
        name: `Cafés Gourmands (${quantity} pièces)`,
        price: price,
        image: IMAGES[0],
        category: "Cafés Gourmands",
        description: `${quantity} pièces`
      },
      1
    );

  };

  return (

    <div className="bg-white rounded-2xl shadow p-8 max-w-xl">

      <img
        src={IMAGES[selectedImage]}
        alt="Cafés Gourmands"
        className="w-full h-64 object-contain rounded-xl mb-3"
      />

      <div className="flex gap-3 mb-6">
        {IMAGES.map((img, i) => (
          <button
            key={img}
            onClick={() => setSelectedImage(i)}
            className={`w-16 h-16 rounded-lg overflow-hidden border-2 transition-colors ${
              selectedImage === i ? "border-primary" : "border-gray-200 hover:border-gray-400"
            }`}
          >
            <img src={img} alt={i === 0 ? "Vue extérieure" : "Vue intérieure"} className="w-full h-full object-cover" />
          </button>
        ))}
      </div>

      <h2 className="text-2xl font-semibold mb-2">
  Coffret Cafés Gourmands
</h2>

<p className="text-gray-500 text-sm leading-relaxed mb-4">
  Succombez à la douceur de notre verre en chocolat au lait, garni d'une crème onctueuse au mascarpone parfumée au praliné noisette. 
  Le tout est sublimé par une ganache intense au café et le croquant d'une praline noisette artisanale. 
  Un pur moment de gourmandise !
</p>

<p className="text-gray-600 mb-6">
  Choisissez le nombre de pièces. Minimum 4 pièces.
</p>

      <div className="flex items-center gap-6 mb-6">

        <button
          onClick={decrease}
          className="w-10 h-10 rounded-full border flex items-center justify-center text-xl"
        >
          −
        </button>

        <span className="text-xl font-semibold">
          {quantity} pièces
        </span>

        <button
          onClick={increase}
          className="w-10 h-10 rounded-full border flex items-center justify-center text-xl"
        >
          +
        </button>

      </div>

      <p className="text-lg mb-6">
        Prix : <span className="font-bold">{price} €</span>
      </p>

      <button
        onClick={handleAddToCart}
        className="btn-primary w-full"
      >
        Ajouter au panier
      </button>

    </div>

  );
};

export default CafeBoxCalculator;